import React from "react";
import PropTypes from "prop-types";

const DateField = ({
  label,
  name,
  value,
  onChange,
  className = "border p-2 w-full rounded-md",
  placeholder,
  autocomplete,
  error,
  min,
  max,
}) => {
  const handleChange = ({ target }) => {
    onChange({ name: target.name, value: target.value });
  };

  return (
    <div className="mt-4">
      <div className="input-group flex flex-col">
        {label && (
          <label htmlFor={name} className="mb-1 font-medium">
            {label}
          </label>
        )}
        <input
          type="date"
          id={name}
          name={name}
          autoComplete={autocomplete}
          value={value}
          onChange={handleChange}
          className={className}
          placeholder={placeholder}
          min={min}
          max={max}
        />
        {error ? (
          <div className="h-5 text-red-400 text-sm">{error}</div>
        ) : (
          <div className="h-5"> </div>
        )}
      </div>
    </div>
  );
};

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  min: PropTypes.string, // формат YYYY-MM-DD
  max: PropTypes.string, // формат YYYY-MM-DD
};

export default DateField;
